import apiClient from './api';

export const inviteWorkerToRoster = async (workerProfileId) => {
  try {
    const response = await apiClient.post('/broker/roster/invite', { workerProfileId });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getBrokerRoster = async () => {
  try {
    const response = await apiClient.get('/broker/roster');
    return response.data;
  } catch (error) {
    throw error;
  }
};
